import _ from 'lodash'

export class DailyTableData {
  public constructor (
    readonly employee: string,
    readonly time: string,
    readonly entry: string,
    readonly conflict: string
  ) {}

  static createListFromResponse (data: any): Array<DailyTableData> {
    let dailyTableData: Array<DailyTableData> = []

    _.each(data, (val, key) => {
      if (key === 'shift') {
        val.forEach((item: any) => {
          dailyTableData.push(new DailyTableData(
            item.employee_name,
            item.time_label,
            item.label,
            item.conflict)
          )
        })
      } else if (key === 'absences') {
        val.forEach((item: any) => {
          dailyTableData.push(new DailyTableData(
            item.employee_name,
            item.time_label,
            item.label,
            item.conflict)
          )
        })
      } else if (key === 'calendar') {
        val.forEach((item: any) => {
          dailyTableData.push(new DailyTableData(
            item.employee_name,
            item.time_label,
            item.label,
            item.conflict)
          )
        })
      }
    })

    return dailyTableData
  }
}
